// @flow
import React from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { Header } from "semantic-ui-react";

import { formatCurrency } from "modules/Offers/misc/Utils";
import { Icon } from "modules/ChangeService/Wizard/misc/components/IconOptions";

import Styles from "./YearlySavings.module.scss";

type Props = {
  savings: number,
  categoryType: ?string,
  fullWidth?: boolean,
};

const YearlySavings = ({ savings, categoryType, fullWidth }: Props) => {
  const { t } = useTranslation("offerPageDetail");
  const categoryName = categoryType ? `${t(`categories:${categoryType}`)}` : "";
  const fiveYearSavings = savings ? savings * 5 : 0;
  const formattedFiveYearSavings = formatCurrency(fiveYearSavings).replace("€", "");
  const bonus = savings
    ? `(Ihre Ersparnis von ${formatCurrency(savings).replace("€", "")} x 5 = ${formattedFiveYearSavings} Euro)`
    : t("specialOffer:furtherText.emptyBonus");

  return (
    <div className={Styles.yearlySavings}>
      <div className={classnames(Styles.responsiveContent, { [Styles.fullWidth]: fullWidth })}>
        <div className={Styles.block}>
          <div className={Styles.circle}>
            <Icon name="coins" className="theme-color-primary" />
          </div>
          <Header as="h3">
            {t("process.left.title")}
            <Header.Subheader>{t("process.left.description", { categoryName })}</Header.Subheader>
          </Header>
        </div>
        <div className={Styles.block}>
          <div className={Styles.circle}>
            <Icon name="circulararrow" className="theme-color-primary" />
          </div>
          <Header as="h3">
            {t("process.right.title")}
            <Header.Subheader>{t("process.right.description", { formattedFiveYearSavings, bonus })}</Header.Subheader>
          </Header>
        </div>
      </div>
    </div>
  );
};

export default YearlySavings;
